import {useState, useEffect} from "react";
import {getFieldNameBuilder} from "../../util";
export const IssuanceEarnedPoints = props => {

  let pointTypes = props.pointTypes;
  if( props.data && 'function' === typeof props.pointTypes) {
    pointTypes = pointTypes(props.data.getValue);
  }

  let prefix = props.prefix || '',
    getFieldName = getFieldNameBuilder(prefix),
    pointsInit = props.value || [];

  if (!pointsInit.length) {
    for( const id_title of pointTypes ) {
      pointsInit.push( {
        point_type_id: id_title.id,
        count: 0
      } );
    }
  }

  const [pointCounts, setPointCounts] = useState( pointsInit || [] );
  useEffect(() =>  {
    props.onChange ? props.onChange(pointCounts) : null
  } , [pointCounts])

  let pointsById = {};
  for( const id_title of pointTypes ) {
    pointsById[ id_title.id.toString() ] = { id: id_title.id, title:  id_title.title };
  }

  // Awkward way of zipping these 2 together since data for them does not arrive at the same time
  for(const id_count of pointCounts ) {
    let by_id = pointsById[ id_count.point_type_id.toString() ];
    if( by_id ) {
      by_id.count = id_count.count;
    }
  }

  return (
    <>
      {Object.values(pointsById).length &&
        <h2>Earned Points</h2>
      }
      {Object.values(pointsById).map((point, i) => {
        return (
          <div key={i} className={'earned-points-container'}>
            {tangibleFields.render({
              type: 'hidden',
              name: getFieldName(`${point.id}_earned_point_id`),
              value: point.id,
            })}
            <label>{point.title}
              {tangibleFields.render({
                type: 'number',
                name: getFieldName(`${point.id}_earned_point_count`),
                value: point.count ?? 0,
                label: '',
                min: 0,
                onChange: (count) => {
                  // Create a new array with updated count
                  const newPointCounts = pointCounts.map(id_count => {
                    if (parseInt(id_count.point_type_id) === parseInt(point.id)) {
                      return { ...id_count, count: count };
                    }
                    return id_count;
                  });

                  setPointCounts(newPointCounts);
                }
              })}
            </label>
          </div>
        )
      })}

    </>
  )
}
